/* Marca en negrita los packs dentro de las grillas de productos */
(function () {
  function marcar() {
    document.querySelectorAll('a, h3, .product-card__title, [class*="card__title"]').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/^Pack\s/i.test(t) && t.length < 120 && !el.classList.contains('gu-pack-title')) {
        el.classList.add('gu-pack-title');
        var card = el.closest('.product-card, .card--product, [class*="product-card"], li, article');
        if (card) card.classList.add('gu-pack-card');
      }
    });
  }
  marcar();
  new MutationObserver(marcar).observe(document.body, { childList: true, subtree: true });
})();
/* botón flotante de inicio con la conejita (no se muestra en la home) */
(function () {
  if (location.pathname === '/' || document.querySelector('.gu-home-btn')) return;
  var a = document.createElement('a');
  a.className = 'gu-home-btn';
  a.href = '/';
  a.setAttribute('aria-label', 'Volver al inicio');
  a.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0844/2055/9067/files/favicon-glow-boton.png?v=1786879642" alt="" loading="lazy"><span>Inicio</span>';
  document.body.appendChild(a);
})();
